// extracted by mini-css-extract-plugin
export default {"productGallery":"RJ-z","inQuickShop":"SJ-z"};